import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import './Confermation.scss'

function ConfermationModal(props) {
    const { setConfermationModal, confermationModal, confermationHeading, confermationMessage, buttonLable, handleDelete , isLoading , warning } = props
    const toggle = () => setConfermationModal(!confermationModal)

    return (
        <div>
            <Modal isOpen={confermationModal} toggle={toggle} {...props}>
                <ModalHeader toggle={toggle}><h6>{confermationHeading}</h6></ModalHeader>
                <ModalBody className='text-center'><b>{confermationMessage}</b>
                {warning && warning != '' ? <p className='text-center small'>{warning}</p> : ''}

                </ModalBody>
                
                <ModalFooter>
                    <Button className='modalButton' color={buttonLable === 'Delete' ? 'danger' : 'primary'} disabled={isLoading ? true : false} onClick={handleDelete}>{buttonLable}</Button>{' '}
                    <Button className='modalButton' color="secondary" onClick={toggle}> Cancel </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

ConfermationModal.propTypes = {
    dispatch: PropTypes.func,
    setConfermationModal: PropTypes.func,
    confermationModal: PropTypes.bool,
    confermationHeading: PropTypes.string,
    confermationMessage: PropTypes.string,
    buttonLable: PropTypes.string,
    handleDelete: PropTypes.func,
    isLoading: PropTypes.bool,
    warning : PropTypes.string
}

ConfermationModal.defaulProps = {
    dispatch: noop,
    setConfermationModal: PropTypes.func,
    confermationModal: PropTypes.bool,
    confermationHeading: PropTypes.string,
    confermationMessage: PropTypes.string,
    buttonLable: PropTypes.string,
    handleDelete: PropTypes.func,
    isLoading : PropTypes.bool,
    warning : PropTypes.string
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(ConfermationModal)